<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="String($t('approval_line'))")
    b-container(fluid :class="{ 'is-mobile': isMobile }")
      .context.required
        b-form
          b-form-group.d-flex.align-items-center(
            v-for="n in 4"
            :key="n"
            content-cols-sm
            :label="$t('step_n', { n: n })"
            label-for="device-name"
            label-cols-sm="2"
            label-align-sm="left"
            :class="requiredStep >= n ? 'required' : ''"
          )
            .d-flex.align-items-center
              b-form-input#device-name.input-wid-1(:placeholder="form[`step${n}`].print" disabled size="sm")
              b-button.ml-3(size="sm" @click="handlerDialogApprover(n)") {{$t('selection')}}
              b-button.ml-2(size="sm" variant="outline-danger" @click="handlerDelete(n)") {{$t('delete')}}

    .modal-footer
      b-button(size="sm" variant="primary" @click="submit" pill) {{$t('apply')}}
      b-button(variant="secondary" size="sm" @click="visible = false" pill) {{$t('cancel')}}

    dialog-approver2(
      :show.sync="showDialogApprover"
      :title="String($t('dialogs_page.approver_selection'))"
      :step="step"
      :userId="userId"
      @select="selectApprover"
    )
</template>

<script>
import Dialogs from "@/components/mixins/dialog/index.vue"
import DialogApprover2 from "@/components/user/components/dialogApprover2.vue"
import _ from "lodash"

const defaultForm = {
  step1: {
    id: null,
    pk: null,
    name: null,
  },
  step2: {
    id: null,
    pk: null,
    name: null,
  },
  step3: {
    id: null,
    pk: null,
    name: null,
  },
  step4: {
    id: null,
    pk: null,
    name: null,
  },
}
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    limit: {
      type: Number,
      default: 0,
    },
    userId: {
      type: String,
      default: null,
    },
  },
  components: {
    Dialogs,
    DialogApprover2,
  },
  computed: {
    isMobile() {
      if (this.AppState.isApplication) return true
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
  },
  watch: {
    show(newVal) {
      this.visible = newVal
      if (newVal) {
        this.form = _.cloneDeep(defaultForm)
        if (this.limit > 0) this.requiredStep = this.limit
        if (_.isEmpty(this.data)) return
        const id = String(this.data.id).split(",")
        const pk = String(this.data.pk).split(",")
        const name = this.data.name.split(",")
        this.requiredStep = _.isEmpty(this.data.name) ? 0 : name.length
        for (const [index, item] of name.entries()) {
          this.form[`step${index + 1}`].id = id[index]
          this.form[`step${index + 1}`].pk = pk[index]
          this.form[`step${index + 1}`].name = item
          this.form[`step${index + 1}`].print = !_.isEmpty(item) ? `${item} (${id[index]})` : ""
        }
      }
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
      showDialogApprover: false,
      requiredStep: 0,
      step: 1,
      form: _.cloneDeep(defaultForm),
    }
  },
  methods: {
    selectApprover(item, step) {
      this.form[`step${step}`].id = item.id
      this.form[`step${step}`].pk = item.pk
      this.form[`step${step}`].name = item.name
      this.form[`step${step}`].print = `${item.name} (${item.id})`
      this.showDialogApprover = false
    },
    handlerDialogApprover(step) {
      this.step = step
      this.showDialogApprover = true
    },
    handlerDelete(step) {
      const form = _.cloneDeep(this.form)
      form[`step${step}`].id = null
      form[`step${step}`].pk = null
      form[`step${step}`].name = null
      form[`step${step}`].print = null

      this.form = form
    },
    submit() {
      if (this.limit > 0) {
        for (let i = 1; i <= this.limit; i++) {
          if (!this.form[`step${i}`].name) {
            this.$bvToast.toast(this.$t('approval_line_limit', {limit: this.limit}), {
              title: "Error",
              variant: "danger",
              solid: true,
            })
            return
          }
        }
      }
      this.$emit("submit", this.form)
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}
.btn-secondary {
  color: #6f6f6f;
  border-color: #6f6f6f;
  background-color: #fff;
  text-align: center;
}
.input-wid-1 {
  width: 70%;
}
.is-mobile {
  .input-wid-1 {
    width: 65%;
  }
}
</style>
